import { render, staticRenderFns } from "./Notallowpage.vue?vue&type=template&id=4318b5f1&"
import script from "./Notallowpage.vue?vue&type=script&lang=js&"
export * from "./Notallowpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports